import { get, mergeWith } from 'lodash/object';
import { cloneDeep } from 'lodash/lang';

const overwriteArrays = (currentConfig, newConfig) => {
  if (Array.isArray(newConfig)) {
    return newConfig;
  }
};

export const substituteVariablesInString = (inputString, dataSourceObject) => {
  // replace all variables in inputString with matching values provided in a source object
  if(!inputString) return undefined;
  if(!dataSourceObject) return inputString;

  const regexVariablePattern = /(\$\{)([a-zA-Z0-9.]+)(\})/g; // using a variable pattern similar to string interpolation (e.g. ${namespace.variableName})
  const replacerFunction = (match, openingBracket, variable, closingBracket) => variable; // extracts "namespace.variableName" from "${namespace.variableName}"

  const inputVariables = inputString.match(regexVariablePattern);

  if(!inputVariables) return inputString;

  let result = inputString;
  inputVariables.forEach(variableInEnclosedBrackets => {
    const variableName = variableInEnclosedBrackets.replace(regexVariablePattern, replacerFunction); // "${namespace.variable}" -> "namespace.variable"
    const valueToSubstitute = get(dataSourceObject, variableName);
    result = result.replace(variableInEnclosedBrackets, valueToSubstitute || variableName); // replace all instances of ${namespace.variable} with the given value
  });

  return result;
};

export const getValueFromConfig = (config, key, keyPathToOverride) => {
  return get(config, `${keyPathToOverride}.${key}`, get(config, key));
};

// export const mergeConfigs = (configs) => {
//   const clone = cloneDeep(defaultConfig);
//   return mergeWith(clone, Array.isArray(configs) ? configs : [configs], overwriteArrays);
// };

export const mergeConfigs = (...configs) => {
  const clones = configs.map(config => cloneDeep(config));
  return mergeWith(...[...clones, overwriteArrays]);
};

export const getConfigWithNetworkOverrides = (config, paymentNetwork) => {
  const clone = cloneDeep(config);
  return mergeWith(clone, get(config, `paymentNetworks.${paymentNetwork}`, {}), overwriteArrays);
};
